import React, { useRef, useEffect } from 'react';
import SignaturePad from 'signature_pad';

export default function SignatureCapture({ onSave, width = 340, height = 160, clearLabel = 'Limpiar', saveLabel = 'Guardar firma' }) {
  const canvasRef = useRef(null);
  const padRef = useRef(null);

  useEffect(() => {
    if (canvasRef.current) {
      padRef.current = new SignaturePad(canvasRef.current, {
        backgroundColor: '#fff',
        penColor: '#222',
        minWidth: 2,
        maxWidth: 3.5,
      });
    }
    return () => {
      if (padRef.current) padRef.current.off();
    };
  }, []);

  const handleClear = () => {
    padRef.current && padRef.current.clear();
  };

  const handleSave = () => {
    if (padRef.current && !padRef.current.isEmpty()) {
      const dataUrl = padRef.current.toDataURL();
      onSave && onSave(dataUrl);
    }
  };

  return (
    <div style={{ textAlign: 'center', background: '#d1f2fc' }}>
      <canvas
        ref={canvasRef}
        width={width}
        height={height}
        style={{ borderRadius: 8, background: '#fff', touchAction: 'none' }}
      />
      <div style={{ marginTop: 8 }}>
        <button onClick={handleClear} style={{ marginRight: 12, padding: '6px 18px', background: '#64748b', color: 'white', border: 'none', borderRadius: 4, fontWeight: 600 }}>
          {clearLabel}
        </button>
        <button onClick={handleSave} style={{ padding: '6px 18px', background: '#22c55e', color: 'white', border: 'none', borderRadius: 4, fontWeight: 600 }}>
          {saveLabel}
        </button>
      </div>
    </div>
  );
}
